import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-footer" }
const _hoisted_2 = { class: "footer-logo-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "app-name" }
const _hoisted_5 = { class: "copyright" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", { href: "https://www.spinningtop.it/" }, "Spinning Top", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        id: "footer-logo",
        src: _ctx.footerLogoUrl,
        alt: "logo"
      }, null, 8, _hoisted_3),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.config.app.logos.footerTitle), 1)
    ]),
    _createElementVNode("span", _hoisted_5, [
      _createTextVNode(_toDisplayString(_ctx.t("gen.developedby")) + " ", 1),
      _hoisted_6
    ])
  ]))
}